// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setIsSearchPage from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetIsSearchPage";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled from "styled-components";
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
// Store Custom Code
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import Icon from "@insite/mobius/Icon";

interface OwnProps {
    categories: AutocompleteItemModel[] | null;
    popularCategories?: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteCategoriesStyles;
    isRetailSearchCompletionResults?: boolean;
}

const mapDispatchToProps = {
    setIsSearchPage,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface AutocompleteCategoriesStyles {
    headerText?: TypographyPresentationProps;
    subHeaderText?: TypographyPresentationProps;
    categoryItemText?: TypographyPresentationProps;
    divider?: InjectableCss;
    focusedCategoryItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    autocompleteCategoriesRowWrapper?: InjectableCss;
    autocompleteCategoriesColumnWrapper?: InjectableCss;
    note?: TypographyPresentationProps;
}

export const autocompleteCategoriesStyles: AutocompleteCategoriesStyles = {
    headerText: autocompleteProps.headerText,
    autocompleteCategoriesColumnWrapper: autocompleteProps.autocompleteColumnWrapper,
    subHeaderText: autocompleteProps.subHeaderText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    note: autocompleteProps.note,
};

const styles = autocompleteCategoriesStyles;

/* Store Custom Code - a leading navigation icon before each row */
const ItemRow = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

class AutocompleteCategories extends React.Component<Props> {
    private readonly styles: AutocompleteCategoriesStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    renderCategories = (categories: AutocompleteItemModel[]) => {
        const styles = this.styles;
        return (
            <List>
                {categories.map(category => (
                    /* Store Custom Code - Start */
                    <ItemRow key={`${category.id}`}>
                        <Icon src={ArrowRight} size={16} color="#5C6163" />
                        <Link
                            {...(this.props.focusedItem === category ? styles.focusedLink : styles.link)}
                            onClick={() => {
                                this.props.setIsSearchPage(false);
                                this.props.goToUrl(category.url);
                            }}
                            className="autocomplete-categories-link"
                        >
                            {category.displayTitle}
                            {category.displaySubtitle ? (
                                <Typography {...styles.note} className="autocomplete-categories-note">
                                    <>{` ${translate("in")}`}</> {category.displaySubtitle}
                                </Typography>
                            ) : null}
                        </Link>
                    </ItemRow>
                    /* Store Custom Code - End */
                ))}
            </List>
        );
    };

    render() {
        const { categories, popularCategories, isRetailSearchCompletionResults } = this.props;
        if ((!categories || categories.length === 0) && (!popularCategories || popularCategories.length === 0)) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteCategories_Header"
                    className="autocomplete-categories-header"
                >
                    {translate("Categories")}
                </Typography>

                {categories &&
                    categories.length > 0 &&
                    !isRetailSearchCompletionResults &&
                    this.renderCategories(categories)}

                {isRetailSearchCompletionResults && (
                    <>
                        {popularCategories && popularCategories.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteCategoriesColumnWrapper}
                                className="autocomplete-categories-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteCategories_subHeader"
                                    className="autocomplete-categories-subheader"
                                >
                                    {translate("popular")}
                                </Typography>
                                {this.renderCategories(popularCategories)}
                            </StyledWrapper>
                        )}
                        {categories && categories.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteCategoriesColumnWrapper}
                                className="autocomplete-categories-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteCategories_subHeader"
                                    className="autocomplete-categories-subheader"
                                >
                                    {translate("suggested")}
                                </Typography>
                                {this.renderCategories(categories)}
                            </StyledWrapper>
                        )}
                    </>
                )}
            </>
        );
    }
}

export default connect(null, mapDispatchToProps)(AutocompleteCategories);
